var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqsIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10637_17198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.30859 14.1648V11.2807H11.5532V9.03613H14.4373V11.2807H16.6819V14.1648H14.4373V16.4094H11.5532V14.1648H9.30859Z",
    stroke: "#148D9B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9933 20.0865C17.0477 20.0865 20.3538 16.7803 20.3538 12.726C20.3538 8.67163 17.0477 5.36548 12.9933 5.36548C8.93897 5.36548 5.63281 8.67163 5.63281 12.726C5.63281 16.7803 8.93897 20.0865 12.9933 20.0865Z",
    stroke: "#148D9B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34766 23.3989H17.6522",
    stroke: "#148D9B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.998 31.3607L6.64785 27.5173C3.00276 25.3111 0.777344 21.3591 0.777344 17.1001V5.76835C3.61028 5.76835 5.90604 3.47258 5.90604 0.639648H20.0963C20.0963 3.47258 22.3921 5.76835 25.225 5.76835V17.1001C25.225 21.3591 22.9996 25.3111 19.3545 27.5173L13.0044 31.3607H12.998Z",
    stroke: "#148D9B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10637_17198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.7266,
    height: 32,
    fill: "white",
    transform: "translate(0.136719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqsIcon4);
export default __webpack_public_path__ + "static/media/faqs-icon-4.e8d1da8abd39251206e1a711db143144.svg";
export { ForwardRef as ReactComponent };